import { Container, Contents, ItemTitle, Title } from "../styles";

const PrivacyPolicy = () => {
  return (
    <Container>
      <Title>개인정보 처리방침</Title>

      <Contents>
        <span>개정 2023.01.01</span>

        <ItemTitle>개인정보 처리방침의 기본방향</ItemTitle>
        <span>
          "브이디김대표"은 웹 앱을 플랫폼으로 한 인터넷 서비스(이하, 총칭
          "서비스")를 제공합니다. 본 서비스는 서비스 사용자(이하, "귀하")를
          위해 브이디컴퍼니㈜(이하, "당사", "우리")가 운영합니다. 본 개인정보
          보호 정책은 본 사이트 방문객과 앱 및/또는 서비스의 사용자로부터 수집한
          정보와 관련하여 당사의 정책을 제시합니다. 적용법에
          따라 브이디컴퍼니㈜은 본 서비스를 통해 수집된 개인정보의 "데이터
          컨트롤러(Data Controller)"입니다. 당사의 개인정보 처리방침은 관련 법령
          및 정보통신부가 제정한 개인정보보호지침을 준수하고 있으며, 개인정보가
          유출되어 피해를 입지 않도록 개인정보 보호에 최선을 다할 것입니다. 회원
          여러분은 언제든지 이 처리방침을 열람하여 확인하실 수 있으며, 개인정보
          처리방침은 법령 및 정부지침의 변경과 보다 나은 서비스 제공을 위해서 그
          내용이 변경될 수 있습니다.
        </span>

        <ItemTitle>당사가 수집하는 정보</ItemTitle>
        <span>
          서비스를 통해 당사와 상호작용할 때, 당사는 다음과 같은 경우에 귀하가
          제공하는 정보를 귀하로부터 수집할 수 있습니다. 귀하가 서비스에
          액세스하거나 특정 서비스를 사용하기 위해 등록하는 경우와 같이 정보를
          자발적으로 제공할 때 정보를 수집합니다.
        </span>

        <ul>
          <li>
            자동으로 수집하는 정보: 본 서비스 내에서 당사와 소통할 때, 당사는 IP
            주소, 장치 ID 및 서비스 내의 귀하의 활동 등 특정 정보를 수신 및
            저장합니다. 당사는 해당 정보를 저장할 수 있으며, 해당 정보는 제휴사,
            대리인 또는 서비스 제공자가 소유 및 유지 관리하는 데이터베이스에
            포함될 수 있습니다.
          </li>
          <li>
            통합 정보: 본 서비스 사용자를 잘 이해하고 서비스를 제공하기 위해
            당사는 수집된 정보를 근거로 고객 수 통계, 관심 및 행동에 대한 연구를
            수행합니다. 본 연구는 통합적으로 수집되고 분석되며, 당사는 본 통합
            정보를 제휴사, 대리인 및 비즈니스 파트너와 공유합니다. 또한, 현재 및
            미래 비즈니스 파트너와 기타 합법적인 목적으로 제삼자에게 당사의
            서비스를 설명하기 위하여 사용자 통합 통계를 공개할 수 있습니다.
          </li>
          <li>
            다른 서비스를 통한 정보: 당사는 다른 서비스에서 귀하의 정보를 수집할
            권한을 가집니다. 예를 들어, 귀하는 Facebook 또는 Google과 같은 소셜
            네트워크 서비스(이하, "SNS")에 귀하의 계정을 연결할 수 있습니다.
          </li>
          <li>
            쿠키: 당사는 로그인한 계정 및 알림 설정과 같은 귀하의 로컬 컴퓨터
            설정을 추적하기 위해 쿠키 및 유사 기술을 사용합니다. 쿠키는 귀하의
            장치 및 브라우저에서 사이트 및 서비스가 설정하여 귀하의 향후 방문 시
            읽을 수 있는 데이터 조각입니다. 본 서비스에 새로운 기능이 추가되면
            추가 데이터를 저장하기 위해 쿠키 사용이 늘어날 수 있습니다. 또한,
            당사는 웹 비콘과 단일 픽셀 gif와 같은 기술을 사용하여 시스템이
            보내는 이메일 열람률과 같은 로그 데이터를 기록합니다.
          </li>
          <li>
            광고: 다른 애플리케이션이나 웹사이트에서 당사의 서비스 광고를 볼 수
            있습니다. 해당 광고 중 하나를 클릭하고 당사 서비스를 설치하면 귀하는
            본 서비스의 사용자가 됩니다. Twitter 및 Facebook을 포함한 광고
            플랫폼(SDK가 당사 서비스에 통합되어 있음)은 본 서비스 외부의 광고
            캠페인 최적화를 위한 정보를 수집할 수 있습니다.
          </li>
        </ul>

        <ItemTitle>당사의 귀하에 관한 정보 사용</ItemTitle>
        <span>
          당사는 본 개인정보 보호 정책을 준수하며 귀하가 제공하는 정보를
          사용합니다. 특정 이유로 귀하가 정보를 제공할 경우, 제공된 이유와
          관련된 정보를 당사가 사용할 수 있습니다. 예를 들어, 이메일로 당사에
          연락한 경우 당사는 귀하의 문의에 대답하고 문제를 해결하기 위해 귀하가
          제공한 정보를 사용하게 됩니다. 또한, 본 서비스에 대한 액세스 권한을
          얻기 위해 정보를 제공할 경우, 당사는 귀하의 정보를 사용하여 귀하에게
          해당 서비스에 대한 액세스 권한을 제공하고, 해당 서비스에 사용을
          모니터링합니다. 또한, 당사 및 자회사와 제휴사(이하, "관련 회사")는 본
          서비스를 통해 수집된 귀하의 정보를 사용하여 본 서비스의 콘텐츠 및
          기능을 개선하고, 사용자를 잘 이해하고, 서비스를 개선할 수 있습니다.
          당사 및 제휴사는 해당 정보를 사용하여 향후 귀하가 관심이 있으리라
          판단되는 서비스를 알리기 위해 귀하에게 연락할 수 있습니다. 이러한
          경우, 당사가 귀하에게 보내는 각 마케팅 커뮤니케이션에는 향후의 마케팅
          커뮤니케이션 수신에 대한 "옵트 아웃(opt-out)"을 허용하는 지침이
          포함됩니다. 또한, 향후 마케팅 커뮤니케이션 수신을 원치 않거나 당사의
          메일링 리스트에서 이름을 제거하고 싶을 경우, 언제든 아래에 명시된
          곳으로 문의하십시오.
        </span>

        <ItemTitle>귀하의 개인정보 처리에 대한 당사의 법적 근거</ItemTitle>
        <span>
          일부 관할 지역의 법률에 따라 귀하의 개인정보 사용 또는 공개에 대한
          법적 근거에 대하여 귀하에게 알려야 합니다. 해당 법률이 적용되는 범위
          내에서, 당사의 법적 근거는 다음과 같습니다.
        </span>

        <ul>
          <li>
            귀하와의 계약상 의무를 이행: 당사의 개인정보 처리 중 대부분은
            사용자와의 계약상 의무를 이행하거나 계약을 맺기 위해 사용자 요청에
            따라 조치를 취하는 것입니다. 예를 들어, 당사는 귀하의 계정을
            생성하고 당사의 서비스를 제공하기 위해 이를 근거로 개인정보를
            처리합니다.
          </li>

          <li>
            합법적인 이익: 대부분의 경우, 대상이 되는 개인의 이해관계 및 기본
            권리와 자유를 침해하지 않는 방식으로 당사의 합법적인 이익을 증진하기
            위한 근거로 개인정보를 처리합니다. 여기에는 다음이 포함됩니다.
          </li>

          <ul>
            <li>안전하고 즐거운 사용자 경험 제공</li>
            <li>고객 서비스</li>
            <li>
              마케팅(예: 새로운 기능에 대해 알려주는 이메일 또는 기타 알림 전송)
            </li>
            <li>당사의 사용자, 직원 및 자산 보호</li>
            <li>
              비즈니스 분석 및 개선(예, 특정 기능의 설계 및 배치를 최적화하기
              위해 당사 서비스를 사용하는 방법에 대해 정보를 수집)
            </li>
            <li> 법적 문제 관리</li>
          </ul>

          <li>
            법적 준수: 당사는 법적 의무를 준수하는 특정 방법으로 개인정보를
            사용하고 공개해야 합니다.
          </li>

          <li>
            개인의 또는 타인의 중요한 이익을 보호: 예를 들어, 당사는 긴급한 의료
            상황을 해결하기 위해 개인정보를 수집 또는 공유할 수 있습니다.
          </li>

          <li>
            동의: 법에 따라 요구되는 경우, 당사는 귀하의 묵시적 또는 명시적
            동의에 근거하여 개인정보를 취급합니다.
          </li>
        </ul>

        <ItemTitle>귀하에 대한 정보 공개</ItemTitle>
        <span>
          당사는 귀하의 정보를 판매하지 않습니다. 당사는 귀하와의 관계에서 본
          정보가 중요한 부분이라 생각합니다. 하지만 아래에 명시된 바와 같이
          귀하의 정보를 특정 제삼자와 공유하는 특정 상황이 있습니다.
        </span>

        <ul>
          <li>
            사업 양도: 사업을 발전시키기 위해 당사는 사업체 또는 자산을 판매
            또는 구매할 수 있습니다. 기업 판매, 합병, 재조직, 파산, 해체 또는
            유사한 사건이 발생할 경우, 귀하의 정보는 이전되는 자산의 일부가 될
            수 있습니다.
          </li>

          <li>동의: 당사는 귀하의 동의 아래 정보를 이전합니다.</li>

          <li>
            관련 기업: 또한, 본 개인정보 보호 정책을 준수하기 위하여 귀하의
            정보를 관련 기업과 공유할 수 있습니다.
          </li>

          <li>
            대리인, 컨설턴트 및 관련 제삼자: 다른 많은 기업처럼 당사는 특정
            비즈니스 관련 기능을 수행하기 위해 다른 기업 또는 개인을 때로
            고용하기도 합니다. 해당 기능의 예로는 메일 정보, 데이터베이스 관리
            및 결제 처리가 있습니다.
          </li>

          <li>
            법률 요구사항: 당사는 법률에 따라 귀하의 정보 공개가 필요할 경우
            또는 해당 조치가 (i) 법적 의무를 준수하기 위해, (ii) 당사 또는 관련
            기업의 권리 또는 자산을 보호하기 위해, (iii) 서비스 또는 일반
            사용자의 개인 보안을 보호하기 위하거나, (iv) 법적 책임에 대해
            보호받기 위해 귀하의 정보를 공개할 수 있습니다.
          </li>

          <li>
            통합 또는 식별할 수 없는 데이터: 당사는 비즈니스 목적으로 당사의
            파트너사 또는 다른 사람들과 통합 데이터 또는 개인 식별이 불가능한
            정보를 공유할 수도 있습니다.
          </li>
        </ul>

        <ItemTitle>자발적 정보</ItemTitle>
        <span>
          귀하는 당사에 신제품, 기존 제품의 수정 및 기타 자발적인 의견(총칭,
          "자발적 정보")을 제공할 수 있습니다. 모든 자발적 정보는 기밀로
          간주하지 않으며, 당사는 해당 자발적 정보를 제한 또는 귀속 없이
          타인에게 자유롭게 복제, 사용, 공개 및 배포할 수 있습니다.
        </span>

        <ItemTitle>다른 웹사이트로의 링크</ItemTitle>
        <span>
          본 개인정보 보호 정책은 본 서비스에만 적용됩니다. 서비스는 당사가 운영
          또는 관리하지 않는 다른 웹사이트(이하, "제삼자 사이트")로의 링크가
          포함될 수 있습니다. 여기에 명시된 정책 및 절차는 제삼자 사이트에
          적용되지 않습니다. 서비스의 링크가 제삼자 사이트를 보증하거나
          검토했음을 의미하지 않습니다. 해당 사이트의 개인정보 보호 정책의
          정보에 대해서는 직접 해당 사이트로 문의하시기를 바랍니다.
        </span>

        <ItemTitle>데이터 보존</ItemTitle>
        <span>
          당사는 일반적으로 여기에 명시된 목적과 관련이 있는 한 개인정보를
          보유합니다. 개인정보를 삭제하기 위해 당사는 이를 익명화하거나,
          삭제하거나, 다른 적절한 조치를 취할 수 있습니다. DB에 저장된 파일은
          최근 1년 이상 앱 로그인 접속 기록이 없는 경우 모든 파일을 삭제합니다.
        </span>

        <ItemTitle>보안</ItemTitle>
        <span>
          당사는 서비스를 통해 제공된 정보를 분실, 오용 및 무단 액세스, 공개,
          변경 또는 파괴에서 보호하기 위하여 합당한 조치를 취합니다. 하지만
          인터넷이나 이메일 전송이 완벽하게 안전하거나 오류가 없는 것은
          아닙니다. 특히, 서비스가 수신 또는 발신하는 이메일은 안전하지 않을 수
          있습니다. 그러므로 이메일로 당사에 보내는 정보를 결정할 때는 각별히
          주의하십시오. 인터넷을 통해 모든 정보를 공개할 때 이 점을 유의하시기를
          바랍니다.
        </span>

        <ItemTitle>귀하의 데이터 권리 및 선택</ItemTitle>
        <span>
          당사는 서비스를 통해 제공된 정보를 분실, 오용 및 무단 액세스, 공개,
          변경 또는 파괴에서 보호하기 위하여 합당한 조치를 취합니다. 하지만
          인터넷이나 이메일 전송이 완벽하게 안전하거나 오류가 없는 것은
          아닙니다. 특히, 서비스가 수신 또는 발신하는 이메일은 안전하지 않을 수
          있습니다. 그러므로 이메일로 당사에 보내는 정보를 결정할 때는 각별히
          주의하십시오. 인터넷을 통해 모든 정보를 공개할 때 이 점을 유의하시기를
          바랍니다.
        </span>

        <ItemTitle>귀하의 데이터 권리 및 선택</ItemTitle>
        <span>
          당사는 사용자의 위치에 상관없이 사용자를 동등하게 대우해야 한다고
          생각합니다. 따라서 사용자의 위치에 상관없이 모든 사용자가 사용할 수
          있도록 데이터를 관리할 수 있는 옵션을 다음과 같이 만드는 중입니다.
          이메일에 포함된 "수신 거부"를 클릭하여 특정 이메일 수신을 거부할 수
          있습니다. 귀하는 특정 쿠키 관련 처리를 옵트 아웃할 수 있습니다.
        </span>
        <span>
          유럽경제지역, 캐나다, 코스타리카 및 미국 외의 일부 기타 관할 지역에
          거주하는 개인은 당사의 개인정보 보유 여부를 확인하고, 당사가 보유한
          개인정보에 대해 액세스(휴대용 형태의 경우도 포함)하고, 적절한 상황에서
          해당 정보의 수정, 업데이트 또는 삭제할 수 있는 법적 권리를 보유하고
          있습니다. 또한 당사의 개인정보 사용 또는 공개에 이의를 제기하거나,
          해당 정보의 처리에 제한을 요청하거나, 동의를 철회할 수 있습니다. 단,
          이러한 조치는 일반적으로 소급 적용되지 않습니다. 또한, 이러한 조치는
          합법적인 방법으로 정보를 처리하는 능력에 영향을 미치지 않습니다.
        </span>

        <ul>
          <li>
            회사가 보유한 내 개인정보를 어떻게 수정, 업데이트 또는 삭제합니까?
          </li>
          <span>
            서비스의 수정 사항을 당사에 요청할 수 있습니다. 메시지 제목이나
            본문에 "개인정보 요청(Personal Data Request)"이라고 작성한 후,
            행사하고 싶은 데이터 권리에 대한 설명을 함께 ras@vdcompany.co.kr으로
            보내주십시오. 귀하를 보호하기 위해 당사는 요청에 응답하기 전에
            귀하의 신원을 확인할 수도 있습니다.
          </span>

          <li>
            회사가 개인정보를 처리하는 방식을 어떻게 거부하거나 제한합니까?
          </li>
          <span>
            귀하에게는 특정 상황에서 귀하의 개인정보 사용에 대한 중단 또는
            제한을 요청할 수 있는 권리가 있습니다. 예를 들어, 당사가 귀하의
            정보를 계속 사용할 법적 근거가 없을 경우, 또는 귀하의 개인정보가
            정확하지 않다고 생각하는 경우가 있습니다.
          </span>
        </ul>

        <span>
          유럽경제지역의 개인은 직접적인 마케팅 목적으로 개인정보 처리를 거부할
          수 있는 권리가 있습니다. 해당 권리를 행사하려면, 당사의 모든 마케팅
          이메일에 있는 "수신 거부" 링크를 클릭할 수 있습니다.
        </span>
        <span>
          위에 설명된 권리와 옵션은 관련 법률에 따라 제한 및 예외가 있을 수
          있습니다. 이러한 권리 외에도 귀하는 관련 감독 당국에 불만을 제기할
          권리가 있습니다. 하지만, 당사에 먼저 문의하시기를 바라며, 당사는
          귀하의 고민을 해결해드리기 위하여 최선을 다하겠습니다.
        </span>

        <ItemTitle>본 개인정보 보호 정책의 변경</ItemTitle>
        <span>
          당사는 사전 통보 없이 본 개인정보 보호 정책을 수시로 업데이트하거나
          수정할 권리가 있습니다. 특히 정보를 제공하기 전에 본 정책을 정기적으로
          검토하십시오. 본 개인정보 보호 정책은 위에 표시된 날짜에 마지막으로
          업데이트되었습니다. 본 개인정보 보호 정책이 변경 또는 수정된 후에도
          서비스를 계속 사용하면 개정된 개인정보 보호 정책의 조건에 대한 동의를
          나타냅니다.
        </span>

        <ItemTitle>문의하기</ItemTitle>

        <span>
          본 개인정보 보호 정책이나 서비스의 정보 규정에 대해 문의 사항이
          있으시면 언제든 당사에 문의하십시오. 회사는 개인정보 처리에 관한
          업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만 처리
          및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고
          있습니다.
        </span>

        <ul>
          <li>개인정보 보호책임자</li>

          <ul>
            <li>부서명: 신사업본부</li>
            <li>담당자: 정원익</li>
            <li>이메일: ras@vdcompany.co.kr</li>
            <li>연락처: 1833-3482</li>
          </ul>
        </ul>

        <span>
          귀하는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보
          보호 관련 문의, 불만 처리, 피해구제 등에 관한 사항을 개인정보
          보호책임자에게 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해
          지체없이 답변 및 처리해드릴 것입니다.
        </span>
      </Contents>
    </Container>
  );
};

export default PrivacyPolicy;
